import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Navbar from './frontend/components/Navbar';
import ScrollToTop from './frontend/components/ScrollToTop';
import ScrollToTopButton from './frontend/components/ScrollToTopButton';
import FloatingButton from './frontend/components/FloatingButton';
import InspectionModal from './frontend/components/InspectionModal';


import Footer from './frontend/components/Footer';
const Home = lazy(() => import('./frontend/pages/Home'));
const About = lazy(() => import('./frontend/pages/About'));
const ServicesPage = lazy(() => import('./frontend/pages/ServicesPage'));
const Pest = lazy(() => import('./frontend/pages/Pest'));
const Contact = lazy(() => import('./frontend/pages/Contact'));
// const Login = lazy(() => import('./frontend/pages/Login'));



function App() {
  return (

    <Router>

      <Navbar />
      <ScrollToTop />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/pest" element={<Pest />} />
          <Route path="/contact" element={<Contact />} />
          {/* <Route path="/login" element={<Login />} /> */}
        </Routes>
      </Suspense>
      <Footer />
      <FloatingButton />
      <InspectionModal />
      <ScrollToTopButton />

    </Router>

  );
}

export default App;